module.exports = __webpack_public_path__ + "img/Logo_SCL.2acb895a.png";